import React from 'react';
import styles from "./Terms.module.sass"
import Line from "../assets/Line 16.png"
import logo from "../assets/black_logo_order.png"
import {TermsText} from "../components/termsComponents/termsText";
import {NavLink} from "react-router-dom";

export const Terms = () => {
     const GoBackButton = () => (
        <NavLink className={styles.page__terms__backButton} onClick={() => window.history.back()} to="#">
            <span className={styles.page__terms__textButton}>Назад</span>
        </NavLink>
    );
    return (
       <div className={styles.page__terms}>
           <GoBackButton></GoBackButton>
           <div className={styles.page__terms__wrap} >
            <span className={styles.page__terms__header} id='test'>
                Политика в отношении обработки персональных данных
            </span>
               <div className={styles.page__terms__content}>
                   <img className={styles.page__terms__lineImg} src={Line} alt=""/>
                   <img className={styles.page__terms__logoImg} src={logo} alt=""/>
                   <TermsText></TermsText>
               </div>
           </div>
       </div>
    );
};
